// extracted by mini-css-extract-plugin
module.exports = {"list":"Usps_list__2pCTY","item":"Usps_item__2jBqe","title":"Usps_title__233WN","icon":"Usps_icon__2ZhIg"};